<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <div>
      {{ emailVerifiedText }}
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  name: 'hello',
  data () {
    return {
      msg: 'Willkommen',
      emailVerified: firebase.auth().currentUser.emailVerified,
      emailVerifiedText: 'hier'
    }
  },
  created: function () {
    const self = this
    if (firebase.auth().currentUser.emailVerified === false) {
      self.emailVerifiedText = 'Email noch nicht bestätigt'
    } else {
      self.emailVerifiedText = 'Email bestätigt'
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue